document.addEventListener('turbolinks:load', (e) => {
  const videos = document.querySelectorAll('video');
  for(let i = 0; i < videos.length; i++) {
    videos[i].addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    videos[i].setAttribute('controlsList', 'nodownload');
  }
})
